import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeZoomLevel, initializeColorTheme } from "@/utils/eink";
import { initDB } from "@/lib/db";
import { seedIfEmpty } from "@/lib/seedData";
import { registerServiceWorker } from "@/utils/registerSW";
import { isAndroidPlatform } from "@/utils/platform";

// Apply stored settings on app initialization
initializeZoomLevel();
initializeColorTheme();

async function bootstrap() {
  // Only initialize and seed local IndexedDB on Android native app
  if (isAndroidPlatform()) {
    try {
      await initDB();
      await seedIfEmpty();
    } catch (error) {
      console.error("Failed to initialize Android database:", error);
    }
  }

  createRoot(document.getElementById("root")!).render(<App />);
  // Register service worker after app renders
  registerServiceWorker();
}

bootstrap();

